module.exports = __webpack_public_path__ + "static/media/short.a92d824e.jpg";